import { BaseContainerModel } from "../../base-container.model";
import { alg_bot_cf_message_dfn_RowClass } from "../../../dbschema";

export class CfMessageDfnContainerModel extends BaseContainerModel{
  alg_bot_cf_message_dfn: alg_bot_cf_message_dfn_RowClass = new alg_bot_cf_message_dfn_RowClass();
}
